import type { CSSProperties } from 'react';
import type { ImageProps } from 'next/image';
import type { ImageWithFocalPoint } from '../../../wp-blocks/helpers/ImageUpload/ImageUpload';

export type FillImageProps = Omit<ImageProps, 'width' | 'height'> & {
  style: CSSProperties;
};

const objectPositionFromFocalPoint = (
  focalPoint?: ImageWithFocalPoint['focalPoint'],
): string => {
  const x = (focalPoint?.x ?? 0.5) * 100;
  const y = (focalPoint?.y ?? 0.5) * 100;
  return `${x}% ${y}%`;
};

// Strips `width`/`height` (incompatible with Next.js `fill`) and `focalPoint`
// (not a valid DOM attribute) from a WP-sourced image and folds focal-point
// math into `style.objectPosition`. Caller is responsible for passing `fill`
// and `alt` to `<Image>`.
export const getFillImageProps = (
  image: ImageWithFocalPoint,
): FillImageProps => {
  const { width: _w, height: _h, focalPoint, style, ...rest } = image;
  return {
    ...rest,
    style: {
      objectFit: 'cover',
      objectPosition: objectPositionFromFocalPoint(focalPoint),
      ...style,
    },
  };
};
